import { render, staticRenderFns } from "./RejectionDetails.vue?vue&type=template&id=df2e6d10&scoped=true"
import script from "./RejectionDetails.vue?vue&type=script&lang=ts"
export * from "./RejectionDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2e6d10",
  null
  
)

export default component.exports